var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryManagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.912109,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 2.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4121 10H17.2871",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4121 5H17.2871",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59961 3.75L4.88867 6.25L3.53711 5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59961 8.75L4.88867 11.25L3.53711 10",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59961 13.75L4.88867 16.25L3.53711 15",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2871 16.5406V13.4594C17.2868 13.4149 17.2734 13.3712 17.2481 13.3328C17.2228 13.2944 17.1865 13.2626 17.143 13.2406L14.0492 11.6938C14.0075 11.6724 13.9602 11.6611 13.9121 11.6611C13.864 11.6611 13.8167 11.6724 13.775 11.6938L10.6812 13.2406C10.6377 13.2626 10.6015 13.2944 10.5762 13.3328C10.5508 13.3712 10.5374 13.4149 10.5371 13.4594V16.5406C10.5374 16.5851 10.5508 16.6288 10.5762 16.6672C10.6015 16.7056 10.6377 16.7374 10.6812 16.7594L13.775 18.3063C13.8167 18.3277 13.864 18.3389 13.9121 18.3389C13.9602 18.3389 14.0075 18.3277 14.0492 18.3063L17.143 16.7594C17.1865 16.7374 17.2228 16.7056 17.2481 16.6672C17.2734 16.6288 17.2868 16.5851 17.2871 16.5406V16.5406Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6348 15.7656V14.1406L12.2246 12.4688",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2488 13.3312L13.9441 15L10.5762 13.3312",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9437 15L13.9121 18.3375",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryManagement);
export default __webpack_public_path__ + "static/media/inventory-management.d665864670edd3aef9c2dc8556a9ddce.svg";
export { ForwardRef as ReactComponent };